import * as React from "react";
import { RightOutlined } from "@ant-design/icons";

import { RouterTextLink } from "components/actions/RouterLink";
import { appRoutes } from "lib/appRoutes";
import UIcon from "lib/icons/untitled_ui/UIcon";
import { BuyerDetails } from "lib/types/models";

import css from "./BuyerLinkWithLogo.module.scss";

export type BuyerLinkData = Pick<BuyerDetails, "id" | "name" | "guid" | "metadata">;

export type Props = {
  buyer: BuyerLinkData;
};

function BuyerLinkWithLogo({ buyer }: Props): JSX.Element {
  const { metadata } = buyer;
  return (
    <div className={css.container}>
      <div className={css.logo}>
        {metadata?.logo_url ? (
          <img src={metadata.logo_url} alt={buyer.name} />
        ) : (
          <UIcon
            icon="wallet02"
            size={24}
            background={{ color: "sysNeutralSubtle", padding: 18, borderRadius: 4 }}
            color="sysNeutralMuted"
            ariaLabel="Buyer logo placeholder"
          />
        )}
      </div>
      <div className={css.buyerName} title={buyer.name}>
        {buyer.name}
      </div>
      <RouterTextLink className={css.profileLink} {...appRoutes.buyerDetail(buyer.guid)}>
        Visit profile <RightOutlined />
      </RouterTextLink>
    </div>
  );
}

export default BuyerLinkWithLogo;
